import { jsx } from '@emotion/react';
import * as s from './noticeHTML.styles';
import { ArrowRight } from '@rakutenfrance/material-ui-icons';
/**
 * notice consent didomi
 * @returns {*}
 * @constructor
 */
function SpanishNoticeHTML({ noticeText }) {
    const openPreferences = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.preferences)
                window.Didomi.preferences.show();
        }
    };
    const acceptAll = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.setUserAgreeToAll)
                window.Didomi.setUserAgreeToAll();
        }
    };
    const refuseAll = (event) => {
        if (!event.key || (event.key && event.key === 'enter')) {
            if (window.Didomi.setUserDisagreeToAll)
                window.Didomi.setUserDisagreeToAll();
        }
    };
    return (jsx("div", { className: "containerNotice", 
        // eslint-disable-next-line
        css: s.containerNotice },
        jsx("div", { className: "containerTxt", 
            // eslint-disable-next-line
            css: s.containerTxt },
            jsx("span", { className: "titleTxtStyle", 
                // eslint-disable-next-line
                css: s.titleTxtStyle }, "Tus preferencias de cookies"),
            jsx("div", { className: "containerContinueWithoutConsent", onClick: refuseAll, 
                // eslint-disable-next-line
                css: s.containerContinueWithoutConsent },
                jsx("span", { className: "continueWithoutConsentTxtStyle", 
                    // eslint-disable-next-line
                    css: s.continueWithoutConsentTxtStyle }, "Continuar sin aceptar"),
                jsx("span", { className: "containerArrow", 
                    // eslint-disable-next-line
                    css: s.containerArrow },
                    jsx(ArrowRight, { fill: "black", width: "12px", height: "12px" }))),
            jsx("p", { className: "paragraphTxtStyle", 
                // eslint-disable-next-line
                css: s.paragraphTxtStyle },
                "Rakuten France y",
                ' ',
                jsx("span", { className: "vender-list", onClick: () => {
                        var _a;
                        (_a = window.Didomi.preferences) === null || _a === void 0 ? void 0 : _a.show('vendors');
                        // "window.Didomi.preferences.show('vendors')"
                    } }, "sus socios"),
                ' ',
                "procesan tus datos personales (como datos de navegaci\u00F3n, datos de transacciones, informaci\u00F3n de cookies y otros identificadores \u00FAnicos) almacenando y accediendo a la informaci\u00F3n de tu dispositivo, analizando activamente las caracter\u00EDsticas del mismo para identificarte y utilizando tus datos de geolocalizaci\u00F3n precisa para ofrecerte contenidos y anuncios personalizados, medir el rendimiento de los anuncios y contenidos mostrados, conocer su audiencia y desarrollar sus productos. Puedes retirar tu consentimiento en cualquier momento desde la secci\u00F3n \"Gesti\u00F3n de cookies\".")),
        jsx("div", { className: "containerBtn", 
            // eslint-disable-next-line
            css: s.containerBtn },
            jsx("div", { onClick: acceptAll, className: "didomi_accept_button", 
                // eslint-disable-next-line
                css: s.didomi_accept_button, onKeyPress: acceptAll },
                jsx("span", null, "Aceptar y cerrar")),
            jsx("div", { onClick: openPreferences, className: "preferencesBtn", 
                // eslint-disable-next-line
                css: s.preferencesBtn, onKeyPress: openPreferences },
                jsx("span", null, "Configurar")))));
}
export default SpanishNoticeHTML;
